export const vatPrice = (price) => +price + Math.floor((price * 20) / 100) || 0;
export const notVatPriceWithPrepayment = (price, prepayment) => Math.floor((price / 100) * prepayment) || 0;
